import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle, useMemo, useReducer } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import AlertNotification from '../../components/AlertNotification';
import PdfViewerComponent from '../../components/PdfViewerComponent';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    CustomAutoComplete,
    DocumentUtility,
    UtilityLibrary,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    HtmlContentDialog,
    FetchControls,
    DeterminePermissions,
    CaseDetailManager,
    CaseWorkflowService
} from '../../components/ComponentsLibrary';
import PageLoader from '../../components/PageLoader';

import { useConfigContext } from '../../functions/ConfigContext';




const CaseInformation = forwardRef((props, ref) => {

    const {
        onCaseSearchComplete = () => { },
        onBatchDocAvailable = () => { },
        onMessageUpdate = () => { },
        pageName
    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onSelectCaseFromExternal,
        onLoadDocFromBatchExternal,
        onLoadNextDocFromBatchExternal,
        addNewDocumentToGridRow,
        onClearExternalTabs,
        clearCaseTabFromExternal,        
        clearCaseInfoFromExternal,
        fetchCaseDataOnly
    }));

     const { configLibrary } = useConfigContext();
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    const { siteID, stateID, legacyUserID: userLoginID } = SessionManager.GetDataFromSession("LoginUserInfoKey") || {};

    const caseDetailOptions = {
        Document: { id: 1, label: "Documents", value: "DocumentCaseDetail" },
        WorkflowActivity: { id: 2, label: "Workflow Activities", value: "WorkflowActivityCaseDetail" },
        CustomerServiceContacts: { id: 3, label: "Customer Service Contacts", value: "CustomerServiceContacts" },
        Workflows: { id: 4, label: "Workflows", value: "WorkflowsCaseDetail" },
    };

    const caseDetailOptionsForControls = [
        { id: 1, type: "Document", label: "Documents", value: "DocumentCaseDetail" },
        { id: 2, type: "WorkflowActivity", label: "Workflow Activities", value: "WorkflowActivityCaseDetail" },
        { id: 3, type: "CustomerServiceContacts", label: "Customer Service Contacts", value: "CustomerServiceContacts" },
        { id: 4, type: "Workflows", label: "Workflows", value: "WorkflowsCaseDetail" },
    ];

    /*  Legal: { id: 4, label: "Legal", value: "LegalCaseDetail" },
     Workflows: { id: 5, label: "Workflows", value: "WorkflowsCaseDetail" }, */

    // Define action types
    const ACTIONS = {
        ADD: 'ADD',
        REMOVE: 'REMOVE',
        UPDATE: 'UPDATE'
    };

    // Create reducer function to add/remove a STATE
    const itemsReducer = (state, action) => {
        switch (action.type) {
            case ACTIONS.ADD:
                return [...state, action.payload];

            case ACTIONS.REMOVE:
                return state.filter(item => item.caseNumber !== action.payload);

            case ACTIONS.UPDATE:
                return state.map(item =>
                    item.caseNumber === action.payload.caseNumber ? { ...item, ...action.payload.caseInfo } : item
                );

            default:
                return state;
        }
    };

    // Initialize state with useReducer
    const [caseInternalInfo, dispatch] = useReducer(itemsReducer, []);

    // Create a memoized lookup table
    const caseInternalInfoLookup = useMemo(() => {
        return caseInternalInfo.reduce((acc, item) => {
            acc[item.caseNumber] = item;
            return acc;
        }, {});
    }, [caseInternalInfo]);

    // Action creators (optional but recommended)
    const addCaseInfo = (caseInfo) => {
        dispatch({ type: ACTIONS.ADD, payload: caseInfo });
    };

    const removeCaseInfo = (caseNumber) => {
        dispatch({ type: ACTIONS.REMOVE, payload: caseNumber });
    };

    const updateCaseInfo = (caseNumber, caseInfo) => {
        dispatch({ type: ACTIONS.UPDATE, payload: { caseNumber, caseInfo } });
    };


    const [currentCaseID, setCurrentCaseID] = useState("");
    const [currentPanelID, setCurrentPanelID] = useState(pageName === "New Walk-In"
        ? "CustomerServiceContacts"
        : pageName === "Action Taken Details"
        ? "WorkflowActivityCaseDetail"
        : "DocumentCaseDetail"
    );
    const [currentInternalPanelID, setCurrentInternalPanelID] = useState(pageName === "New Walk-In"
        ? "CustomerServiceContacts"
        : pageName === "Action Taken Details"
        ? "WorkflowActivityCaseDetail"
        : "DocumentCaseDetail"
    );
    const [caseDetailLoaded, setCaseDetailLoaded] = useState(false);
    let caseDetailComponentProps = {};

    const errorFormName = "Case Information";

    // Create a ref for the child component
    const panelManagerRef = useRef(null);

    

    // Example: Focus the current component when it changes
    useEffect(() => {
        // if (currentPanelID && caseDetailComponentRefs.current[currentPanelID]) {
        //     caseDetailComponentRefs.current[currentPanelID].current?.focus?.();
        // }
         console.log("🔄 currentPanelID changed to:", currentPanelID);
    }, [currentPanelID]); 


    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmationDialogContent, setConfirmationDialogContent] = useState([]);

    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
    const [notificationDialogContent, setNotificationDialogContent] = useState([]);
    const [notificationDialogPosition, setNotificationDialogPosition] = useState("center")
    const [notificationDialogTimer, setNotificationDialogTimer] = useState(0)
    const [notificationBackdropDismissal, setNotificationBackDropDismissal] = useState(false);
    const [notificationAutoClose, setNotificationAutoClose] =useState(false)

    const [htmlDialogOpen, setHtmlDialogOpen] = useState(false);
    const [htmlDialogTitle, setHtmlDialogTitle] = useState("");
    const [htmlDialogContent, setHtmlDialogContent] = useState("");

    const customDateFormat = "MM/DD/YYYY hh:mm A";
    const caseUniqueID = "caseNumber";

    const batchDocumentProcess = EnumUtility.BatchDocumentProcess;

    // Create a ref for the child component
    const pdfViewerRef = useRef(null);
    const [splitArgs, setSplitArgs] = useState(null);

    const CaseTabType = {
        BATCH: { ID: 100, label: "Batch" },
        CaseExternal: { ID: 200, label: "Case External" },
        CaseInternal: { ID: 300, label: "CaseInternal" },
    };

    const [getBatchDocument, setBatchDocument] = useState({
        BatchID: 0,
        BatchDocumentID: 0,
        DocumentPath: '',
    });

    const TabPanel = ({ children, value, index }) => (
        <div style={{ visibility: value === index ? "visible" : "hidden" }}>{children}</div>
    );

    const [externalCaseTabs, setExternalCaseTabs] = useState([]);
    const [currentExternalCaseTab, setCurrentExternalCaseTab] = useState(false);
    const [caseTabs, setCaseTabs] = useState([]);
    const [currentInternalCaseTab, setCurrentInternalCaseTab] = useState(false);
    const dataRefs = useRef({}); // Store form and DataGrid data persistently
    const currentActiveExternalTab = externalCaseTabs.find((tab) => tab.uniqueID === currentExternalCaseTab);
    const currentExternalTabData = currentActiveExternalTab ? (currentActiveExternalTab.tabKey !== CaseTabType.BATCH.ID ? dataRefs.current[currentActiveExternalTab.pid] : null) : null;
    const currentExternalFormData = currentExternalTabData?.formData || [];
    const currentExternalGridData = currentExternalTabData?.gridData || [];

    const currentActiveInternalTab = caseTabs.find((tab) => tab.uniqueID === currentInternalCaseTab);
    const currentInternalCaseTabData = currentActiveInternalTab ? dataRefs.current[currentActiveInternalTab.pid] : null;
    const currentInternalFormData = currentInternalCaseTabData?.formData || [];

    const [tabIndexCounter, setTabIndexCounter] = useState(0);
    const [showSearch, setShowSearch] = useState(true); // Search panel visible by default   
    const [caseNumberSearch, setCaseNumberSearch] = useState('');
    const caseNumberRef = useRef();
    // Validation patterns
    const siteSettingDetail = JSON.parse(SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey));
    
    //const caseNumberRegex = JSON.parse(SessionManager.GetValueFromSession(SessionManager.CaseNumberRegexKey)) || { caseRegexValue: "", caseRegexMessage: "" };
    const caseNumberRegex = siteSettingDetail.CaseNumberRegex || { caseRegexValue: "", caseRegexMessage: "" };
   
    const [caseSearchResults, setCaseSearchResults] = useState([]);
    const [caseSearchPaginationModel, setCaseSearchPaginationModel] = useState({ pageSize: 15, page: 0 });
    const [hasCaseResults, setHasCaseResults] = useState(false);
    const [initialCaseSearch, setInitialCaseSearch] = useState(false);
    const [caseInfoArray, setCaseInfoArray] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const scrollRef = useRef(null);
    const [document, setDocument] = useState({ 0: { value: "" } });
    const [enableShowBatchDocument, setEnableShowBatchDocument] = useState(false);
    const [uncBatchDocumentUrl, setUncBatchDocumentUrl] = useState('');
    const [enableShowDocument, setEnableShowDocument] = useState(false);
    const [enableShowExternalDocument, setEnableShowExternalDocument] = useState(false);
    const [documentUrl, setDocumentUrl] = useState('');
    const [uncDocumentUrl, setUncDocumentUrl] = useState('');
    const [uncExternalDocumentUrl, setUncExternalDocumentUrl] = useState('');
    const [hasExternalDocResults, setHasExternalDocResults] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState('');

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [testDocLoad, setTestDocLoad] = useState(false);

    /* 
    const [caseDataSessionKey, setCaseDataSessionKey] = useState('CaseDetailsKey');
    const [getCaseDetailsAPI, setGetCaseDetailsAPI] = useState('https://localhost:7183/api/Case/GetCaseList/');
    const [getCaseDocumentsAPI, setGetCaseDocumentsAPI] = useState('https://localhost:7183/api/CaseDocument/GetCaseDocumentList/0/'); */

    const [resultsExternalDocs, setExternalDocResults] = useState([]);
    const [resultsDocs, setDocResults] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [docsSelectedForExport, setDocsSelectedForExport] = useState([]);
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const initialCaseNumberIconsDisabled = { search: false, copy: false, clear: false };
    const [caseNumberIconsDisabled, setCaseNumberIconsDisabled] = useState(initialCaseNumberIconsDisabled);

    const defaultPermissionsForFields = {
        caseNumberTxt: { read: false, write: true, hide: false },
        caseSearchDgrd: { read: false, write: true, hide: false },
        caseNumberLbl: { read: false, write: true, hide: false },
        cpNameLbl: { read: false, write: true, hide: false },
        ncpNameLbl: { read: false, write: true, hide: false },
        statusTypeLbl: { read: false, write: true, hide: false },
        caseTypeLbl: { read: false, write: true, hide: false },
        openedLbl: { read: false, write: true, hide: false },
        caseWorkerLbl: { read: false, write: true, hide: false },
        countyNameLbl: { read: false, write: true, hide: false },
        familyViolenceLbl: { read: false, write: true, hide: false },
        ndiLbl: { read: false, write: true, hide: false },
        confidentialCaseLbl: { read: false, write: true, hide: false },
        specialCircumstanceLbl:{ read: false, write: true, hide: false },
        goodCauseLbl: { read: false, write: true, hide: false },
        nonCoopLbl: { read: false, write: true, hide: false },
        conflictCaseLbl: { read: false, write: true, hide: false },
        caseClosedLbl: { read: false, write: true, hide: false},
        uploadFileBtn: { read: false, write: true, hide: false },
        caseDetailSelect: { read: false, write: true, hide: false },
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        documentsDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrRotateBtn: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
        docVwrDeleteBtn: { read: false, write: true, hide: false },
        docVwrSaveBtn: { read: false, write: true, hide: false },
    };
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);
    const [permissions, setPermissions] = useState({});
    const [permissions_ByEvent, setPermissions_ByEvent] = useState({});

    const documentViewerAccessPermissions = {
        viewOnlyAccess: false,
        editorAccess: formFieldAccess.docVwr1Editor,
        viewerToolbarItemsAccess: formFieldAccess.docVwr1ToolbarItems,
        rotateButtonAccess: formFieldAccess.docVwrRotateBtn,
        // Split / Split All are only available on the Index, Re-Index and Manage Keywords document editors.
        splitButtonAccess: { hide: true },
        deleteButtonAccess: formFieldAccess.docVwrDeleteBtn,
    };

    const toUpperCase = (stringToUpperCase) => {
        return String(stringToUpperCase).toUpperCase();
    };

    const toLowerCase = (stringToLowerCase) => {
        return String(stringToLowerCase).toLowerCase();
    }

    const handleExportCheckboxChange = (id) => {
        setDocsSelectedForExport((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const handleHeaderCheckboxChange = (event) => {
        if (event.target.checked) {
            setDocsSelectedForExport(resultsDocs.map((_, index) => `${resultsDocs[index].batchDocumentID}-${index}`)); // Select all rows
        } else {
            setDocsSelectedForExport([]); // Deselect all rows
        }
    };

    const [alertProps, setAlertProps] = useState({
        type: '',
        message: '',
        open: false,
    });

    // Define the comparator method
    const dateSortComparator = (v1, v2, param1, param2) => {
        const rawDate1 = param1.value;
        const rawDate2 = param2.value;
        const date1 = new Date(rawDate1);
        const date2 = new Date(rawDate2);
        return date1 - date2;
    };

    const displayDateFormatted = (param) => {
        const rawDate = param.value; // Raw value from `field`
        if (!rawDate) return "No date available"; // Handle missing dates
        return formatDistanceToNow(parseISO(rawDate), { addSuffix: true });
    };

    const caseColumns = [
        { field: 'caseNumber', headerName: 'Case ID', minWidth: 100, sortable: true },
        { field: 'cpFullName', headerName: 'CP', minWidth: 120, sortable: true },
        { field: 'ncpFullName', headerName: 'NCP', minWidth: 120, sortable: true },
        { field: 'lastViewed', headerName: 'Last Viewed', minWidth: 120, sortable: true, renderCell: displayDateFormatted, sortComparator: dateSortComparator }
    ];

    const requiredCaseFields = ["caseNumber", "cpFullName", "ncpFullName", "lastViewed"];

    // Grid Columns: Test Data Documents for a Case Number
    const documentGridColumns = [
        { field: 'createdTS', headerName: 'Scan Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 180 },
        { field: 'indexTS', headerName: 'Index Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 180 },
        { field: 'documentGroupTypeName', headerName: 'Group', minWidth: 180 },
        { field: 'documentTypeName', headerName: 'Type', minWidth: 200 },
        { field: 'documentSource', headerName: 'Source', minWidth: 120 },
        { field: 'batchDocumentID', headerName: 'ID', minWidth: 80 },

    ];



    // Add an index to each row
    const resultsExternalDocsWithIndex = (currentGridData) => {
        const gridData = currentGridData ? currentGridData : [];
        const returnData = gridData.map((row, index) => ({
            ...row,
            rowIndex: index, // Add rowIndex property
        }));
        setExternalDocResults(returnData);

        return returnData;
    };

    // Add an index to each row
    const resultsDocsWithIndex = () => {
        const gridData = currentInternalCaseTabData.gridData ? currentInternalCaseTabData.gridData : [];
        const returnData = gridData.map((row, index) => ({
            ...row,
            rowIndex: index, // Add rowIndex property
        }));
        return returnData;
    };



    const showAlert = (type, message) => {
        setAlertProps({ type, message, open: true });
    };

    //=======================================================================
    // Get Methods - Begin
    //=======================================================================

    const getSelectedCaseDetailOption = (panelID) => {
        console.log("🔍 getSelectedCaseDetailOption called with panelID:", panelID);
        const result = caseDetailOptionsForControls.find(opt => opt.value === panelID);
        console.log("✅ Found option:", result);
        return result;
    };

    // CODE_MODIFY: Modify the below function to fetch data from API
    const getCaseDataFromSessionByID = (caseID) => {
        try {
            return SessionManager.GetDataFromSessionByValue(caseID, caseUniqueID, SessionManager.CaseInformationKey);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDataFromSessionByID", {});
        }
    };



    // };

    const getCaseInfoFromApiByID = async (caseID, forceDatabase = false) => {
        try {
            const params = {
                caseNumber: caseID,
                apiMainframeUrl: configLibrary.apiMainframeUrl,
                masterServerDBSchema
            };
            
        
            // Right side search passes forceDatabase=true → DB only (all states).
            // Left side search passes forceDatabase=false → state system / mainframe API.
            const caseApiData = forceDatabase
                ? await ApiManager.GetCaseDataFromDbByID(params)
                : await ApiManager.GetCaseDataFromApiByID(params);

            // The caseApiData should be a standardized object.
            if (!Array.isArray(caseApiData.caseInfo) && caseApiData.caseInfo) {
                // If it's a single object, handle it as before
                caseApiData.caseInfo.lastViewed = new Date().toISOString();
                await updateSessionWithCaseData(caseApiData.caseInfo);
                
                return {
                    caseInfo: caseApiData.caseInfo,
                    statusCode: caseApiData.statusCode,
                    errorMessage: caseApiData.errorMessage,
                    apiError: caseApiData.apiError
                };
            }
            else {
                return {
                    caseInfo: null,
                    statusCode: caseApiData.statusCode,
                    errorMessage: caseApiData.errorMessage,
                    apiError: caseApiData.apiError
                };
            }           
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseInfoFromApiByID", {});
        }
    };

    const getCaseDocsFromSessionByCaseID = (caseID) => {
        try {
            const caseSessionData = SessionManager.GetChildDataFromSessionByParentID(caseID, caseUniqueID, 'caseDocs', SessionManager.CaseInformationKey);
            return caseSessionData;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocsFromSessionByCaseID", {});
        }
    };

    const getCaseDocumentsFromApiByCaseID = async (caseID) => {
        try {
            const params = {
                documentID: 0,
                caseNumber: caseID
            }
            const caseDocsApiData = await ApiManager.GetCaseDocsFromApiByCaseID(params);
            if (caseDocsApiData && caseDocsApiData.length > 0) {
                SessionManager.AddOrUpdateChildToParent(caseUniqueID, caseID, 'caseDocs', 'batchDocumentID', caseDocsApiData, SessionManager.CaseInformationKey);
                return caseDocsApiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocumentsFromApiByCaseID", {});
        }
    };

    // Around line 560 - New helper function to handle session updates
    const updateSessionWithCaseData = async (newCaseData) => {
        try {
            // Get current session data
            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey) || [];
            
            // Find if case already exists
            const existingIndex = storedData.findIndex(item => item.caseNumber === newCaseData.caseNumber);
            
            if (existingIndex !== -1) {
                // Update existing case with new data
                storedData[existingIndex] = { ...storedData[existingIndex], ...newCaseData };
                console.log(`🔍 Updated existing case ${newCaseData.caseNumber} in session storage`);
            } else {
                // Add new case to session data
                storedData.push(newCaseData);
                console.log(`🔍 Added new case ${newCaseData.caseNumber} to session storage`);
            }
            
            // Save updated data back to session
            SessionManager.SetSession(SessionManager.CaseInformationKey, JSON.stringify(storedData));
            
            // Update the search results grid immediately
            updateCaseSearchResultsWithNewCase(newCaseData);
            
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "updateSessionWithCaseData", {});
        }
    };

    const handleBatchTabClick = async (tabKey, id, showDocGrid) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            /* if (tabKey === CaseTabType.BATCH.ID) {
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            }
            else if (tabKey === CaseTabType.CaseExternal.ID) {
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            } */
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleBatchTabClick");
        }
        finally { setIsPageLoading(false); }
    };

    const handleCaseTabClick = async (tabKey, caseID, showDocGrid) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            if (tabKey === CaseTabType.BATCH.ID) {
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            }
            else if (tabKey === CaseTabType.CaseExternal.ID) {
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            }
            else if (tabKey === CaseTabType.CaseInternal.ID) {
                //setDocumentInViewer(-20, "test.txt");
                setEnableShowDocument(false);
                setCurrentInternalPanelID(caseInternalInfoLookup[caseID]?.currentCaseDetailID);
            }

            /* if (tabKey === CaseTabType.BATCH.ID) {
                setSelectedData([]);
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            }
            else if (tabKey === CaseTabType.CaseExternal.ID) {
                const caseSessionData = getCaseDataFromSessionByID(id);
                showCaseDetails(caseSessionData);
                setBatchDocumentInViewer(getBatchDocument.BatchDocumentID, getBatchDocument.DocumentPath);
            }
            else if (tabKey === CaseTabType.CASE.ID) {
                const caseSessionData = getCaseDataFromSessionByID(id);
                showCaseDetails(caseSessionData);
                setDocResults(await getCaseDocsByCaseID(id, showDocGrid) || []);
                setDocumentInViewer(-20, "test.txt");
                setEnableShowDocument(false);
            } */

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseTabClick");
        }
        finally { setIsPageLoading(false); }
    };

    const showCaseDetails = async (caseSessionData) => {
        try {
            const updatedResponse = { ...caseSessionData, "lastViewed": new Date().toISOString() };
            SessionManager.AddOrUpdateParent(updatedResponse, caseUniqueID, SessionManager.CaseInformationKey);
            /* const updatedCaseInfoState = UtilityLibrary.UpdateRecordInArray(updatedResponse, caseInfoArray, caseUniqueID, requiredCaseFields);
            setCaseInfoArray(updatedCaseInfoState); */
            setSelectedData(caseSessionData);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "showCaseDetails", {});
        }
    }

    const getCaseDataByID = async (caseID, forceDatabase = false) => {
        try {
            const caseSessionData = getCaseDataFromSessionByID(caseID);

            const alwaysSearchStateSystem = true; // CODE_MODIFY: Change this to a setting if needed for caching case search results
           
            if (caseSessionData && alwaysSearchStateSystem == false) {
                const updatedResponse = { ...caseSessionData, "lastViewed": new Date().toISOString() };
                SessionManager.AddOrUpdateParent(updatedResponse, caseUniqueID, SessionManager.CaseInformationKey);
                /* const updatedCaseInfoState = UtilityLibrary.UpdateRecordInArray(updatedResponse, caseInfoArray, caseUniqueID, requiredCaseFields);
                setCaseInfoArray(updatedCaseInfoState); */
                //return caseSessionData;
                return {
                    caseInfo: caseSessionData,
                    statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID,
                    errorMessage: ''
                };
            }
            else {
                return await getCaseInfoFromApiByID(caseID, forceDatabase);
            }
        } catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDataByID", {});
        }
    };

    const getCaseDocsByCaseID = async (caseID, showDocGrid) => {
        try {
            if (showDocGrid) {
                const caseDocsSessionData = getCaseDocsFromSessionByCaseID(caseID);
                if (caseDocsSessionData) {
                    return caseDocsSessionData;
                }
                else {
                    return await getCaseDocumentsFromApiByCaseID(caseID);
                }
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocsByCaseID", {});
        }
    };

    // Function to display case information based on the Case Number
    const loadCaseDetailsbyID = async (caseID) => {
        try {
            caseID = toUpperCase(caseID);
            const { hasCaseData, tabAlreadyExists, caseData } = await addCaseTabFromInternal(caseID);
            
            if (hasCaseData) {
                if (!tabAlreadyExists) {
                    addCaseInfo({
                        caseNumber: caseID,
                        caseLoaded: true,
                        currentCaseDetailID: caseDetailOptions.Document.value,
                    });
                    setCurrentInternalPanelID(caseDetailOptions.Document.value);
                }
                else {
                    setCurrentInternalPanelID(caseInternalInfoLookup[caseID]?.currentCaseDetailID);
                }
                
                setEnableShowDocument(false);
                setShowSearch(false);
                setCaseNumberSearch("");
            }
            else {
                const loginUserInfo = sessionService.getUser();
                const userStateID = loginUserInfo ? loginUserInfo.stateID : -1;
                const caseNotFoundError = EnumUtility.getCaseNumberNotFoundError(userStateID);
                
                // Only show error if user is in MS/KS/WY
                if (caseNotFoundError) {
                    const dialogContent = {
                        ...caseNotFoundError,
                        dynamicMessageContent: [caseNumberSearch],
                    };
                    handleNotificationDialog(dialogContent);
                }
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "loadCaseDetailsbyID", {});
        }
    };

    const addCaseInfoToDataRefs = async (caseID, forceDatabase = false, isNoCase = false) => {
        try {
            // Handle no-case scenario
            if (isNoCase) {
                const noCaseData = {
                    formData: {
                        caseNumber: "",
                        cpFirstName: "",
                        cpLastName: "",
                        ncpFirstName: "",
                        ncpLastName: "",
                        caseType: "UNKOWN",
                        caseWorker: "",
                        countyName: "",
                        fviChipDisplay: "",
                        ndiChipDisplay: "",
                    },
                    gridData: [] // No documents for no-case
                };
                
                dataRefs.current[caseID] = noCaseData;
                
                return {
                    caseInfo: noCaseData.formData,
                    statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID,
                    errorMessage: ''
                };
            }

            const alwaysSearchStateSystem = true; // CODE_MODIFY: Change this to a setting if needed for caching case search results
            const cachedCaseData = dataRefs.current[caseID]?.formData;
            // If data is not already loaded, fetch and store it
            if (!dataRefs.current[caseID] || alwaysSearchStateSystem) {
                const caseInfoData = await getCaseDataByID(caseID, forceDatabase);
                let caseData = caseInfoData.caseInfo;
                if (caseInfoData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID && caseData) {
                    const setFVI = dataRefs.current[caseID]?.formData?.fviChipDisplay ? false : true;
                    caseData = await CaseWorkflowService.buildYTracCaseData(caseData, stateID, forceDatabase);

                    const isMainframeIntegration = UtilityLibrary.DetermineIfMainframeHost();
                    if (isMainframeIntegration && forceDatabase == false) {  //Only post updates to API if a mainframe search occured.
                        // Wrap in try-catch: a save failure must not propagate and hide already-fetched case data.
                        try {
                            await ApiManager.PostCaseDataFromScrapeToApi(caseData);
                        } catch (scrapeError) {
                            LoggerUtility.ManageErrorLogging(scrapeError, errorFormName, "PostCaseDataFromScrapeToApi");
                        }
                    }
                    const groupedData = {
                        formData: { ...caseData, fviChipDisplay: setFVI ? caseData?.fviChipDisplay: dataRefs.current[caseID]?.formData?.fviChipDisplay}
                    }
                    dataRefs.current[caseID] = groupedData;
                }


                if (!caseData && cachedCaseData) {
                    return {
                        caseInfo: cachedCaseData,
                        statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID,
                        errorMessage: "",
                    };
                }

                return caseInfoData
            }
            return { caseInfo: dataRefs.current[caseID].formData, 
                     statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID, 
                     errorMessage: '' };
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseInfoToDataRefs", {});
        }
    };

    // Around line 831-885 in addCaseTabFromInternal function
    const addCaseTabFromInternal = async (caseID) => {
        try {
            caseID = toUpperCase(caseID);
            const existingTab = caseTabs.find((tab) => tab.pid.toString() === caseID && tab.tabKey === CaseTabType.CaseInternal.ID);
            
            if (existingTab) {
                // Tab already exists - just activate it and optionally refresh data
                setCurrentInternalCaseTab(existingTab.uniqueID);
                setCurrentExternalCaseTab(false);
                console.log(`🔍 Activated existing internal tab for case ${caseID}`);
                
                const caseInfoData = await addCaseInfoToDataRefs(caseID, true); // Force database for right pane search
                
                // 🔍 FIXED: Use statusCode instead of isCaseFound
                const hasCaseData = caseInfoData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID;
                
                return { 
                    ...caseInfoData,
                    hasCaseData: hasCaseData,
                    tabAlreadyExists: true,
                };
            }
            else {
                // No existing tab - create new one
                const activeTabs = caseTabs.filter((tab) => tab.tabKey === CaseTabType.CaseInternal.ID).length;
                if (activeTabs < 3) {
                    const caseInfoData = await addCaseInfoToDataRefs(caseID, true); // Force database for right pane search
                    const hasCaseData = caseInfoData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID;
                
                    if (hasCaseData) {
                    const newTab = { 
                        tabKey: CaseTabType.CaseInternal.ID, 
                        uniqueID: caseID + "_" + tabIndexCounter, 
                        parentID: 0, 
                        pid: caseID, 
                        label: `CID: ${UtilityLibrary.cleanString(caseID) || ''}`, 
                        showDocumentGrid: true, 
                        canDelete: activeTabs > 0 ? true : false 
                    };
                    
                    setCaseTabs((prevTabs) => [...prevTabs, newTab]);
                    incrementTabCount();
                    setCurrentInternalCaseTab(newTab.uniqueID);
                    setCurrentExternalCaseTab(false);
                    console.log(`🔍 Created new internal tab for case ${caseID}`);
                    }

                    return { 
                        ...caseInfoData,
                        hasCaseData: hasCaseData, 
                        tabAlreadyExists: false, 
                    };
                }
                return { 
                    hasCaseData: false, 
                    tabAlreadyExists: false, 
                    caseInfo: [], 
                    statusCode: EnumUtility.CaseSearchResultCode.OtherError, 
                    errorMessage: 'Maximum tabs reached' 
                };
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseTabFromInternal", {});
        }
    };

    const assignAllCaseDataFromSessionToRefs = () => {
        try {
            // Retrieve session data
            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey);
            if (storedData.length > 0) {
                storedData.forEach((record) => {
                    const primaryKey = record.caseNumber;
                    if (!primaryKey) return; // Skip records without a primary key

                    // Initialize the dataRefs object for this record
                    if (!dataRefs.current[primaryKey]) {
                        dataRefs.current[primaryKey] = { formData: {}, gridData: [] };
                    }

                    // Assign all values except the gridData array
                    Object.keys(record).forEach((key) => {
                        if (Array.isArray(record[key])) {
                            // If it's an array, treat it as gridData
                            dataRefs.current[primaryKey].gridData = record[key];
                        } else {
                            // Otherwise, store it in formData
                            dataRefs.current[primaryKey].formData[key] = record[key];
                        }
                    });
                });
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "assignAllCaseDataFromSessionToRefs", {});
        }
    };


    useEffect(() => {
        try {
            assignAllCaseDataFromSessionToRefs();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "assignAllCaseDataFromSessionToRefs - Page Load");
        }
    }, []);

    /* 
    
        useEffect(() => {
            if (!currentInternalCaseTab) return;
    
            const activeTab = caseTabs.find((tab) => tab.uniqueID === currentInternalCaseTab);
            if (!activeTab) return;
    
            const { uniqueID, pid } = activeTab;
    
            // If data is not already loaded, fetch and store it
            if (!dataRefs.current[uniqueID]) {
                const caseData = getCaseDataByID(pid);
    
                if (caseData) {
                    const responseData = getCaseDocsByCaseID(pid, true);
    
                    const groupedData = {
                        formData: caseData,
                        gridData: responseData
                    }
    
                    dataRefs.current[uniqueID] = groupedData;
                }
    
            }
        }, [currentInternalCaseTab, caseTabs]); */

    //=======================================================================
    // Get Methods - End
    //=======================================================================



    //=======================================================================
    // Action Events - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const handleAddButtonClick = async (tabLength) => {
        try {
            setShowSearch(true);
            setCurrentInternalCaseTab(tabLength);// Reset active tab when showing search
            setCurrentExternalCaseTab(false);
            setViewedCaseIDRecords();
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleAddButtonClick");
        }
        finally { }
    };

    const handleRemoveTab = async (uniqueID, primaryID) => {
        try {
            let filteredTabs;
            setCaseTabs((prevTabs) => {
                filteredTabs = prevTabs.filter((tab) => tab.uniqueID !== uniqueID);
                return filteredTabs;
            });
            removeCaseInfo(primaryID);
            setShowSearch(true);
            setCurrentInternalCaseTab(caseTabs.length - 1);
            setCurrentExternalCaseTab(false);
            setViewedCaseIDRecords();
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleRemoveTab");
        }
        finally { }
    }

    // Function to handle search
    const handleCaseSearch = async (event) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const caseNumberRegexValue = new RegExp(caseNumberRegex.caseRegexValue || "");
            if (caseNumberRegexValue !== "") {
                // valid case number format
                if (caseNumberRegexValue.test(caseNumberSearch)) {
                    setEnableShowDocument(false);
                    await loadCaseDetailsbyID(caseNumberSearch);
                    //setShowSearch(false);
                    setInitialCaseSearch(true);
                }
            }
            else{
                setEnableShowDocument(false);
                await loadCaseDetailsbyID(caseNumberSearch);
                //setShowSearch(false);
                setInitialCaseSearch(true);
            }
           
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseSearch");
        }
        finally { setIsPageLoading(false); }
    };

    // Function to handle clear of case search value
    const handleCaseClear = async () => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();

            setCaseNumberSearch("");
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseClear");
        }
        finally { setIsPageLoading(false); }
    };


    const changeCaseNumberIconsDisable = (iconsEnabledValue) => { // removed async as not needed
        try {
        const updatedCaseNumberIconsEnabled = {
            ...caseNumberIconsDisabled,
            search: iconsEnabledValue.search,
            copy: iconsEnabledValue.copy,
            clear: iconsEnabledValue.clear,
        };
        setCaseNumberIconsDisabled((prevValues) => ({
            ...prevValues,
            ...updatedCaseNumberIconsEnabled
        }));
        }
        catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "changeCaseNumberIconsDisable", {});
        }
    };

    const handleCaseChange = async (e) => {
        try {
            // RC do not make any async calls before case number 
            // state update to ensure the case number cursor stays 
            // in place while editing
            //const { value } = e.target;
            const valueText = e.target.value;

            const caseNumberRegexValue = new RegExp(caseNumberRegex.caseRegexValue || "");

            if (caseNumberRegexValue !== "") {
                // Invalid case number format
                if (!caseNumberRegexValue.test(valueText)) {
                    caseNumberRef.current.setValidationMessage(caseNumberRegex.caseRegexMessage);
                    changeCaseNumberIconsDisable({ search: true, copy: false, clear: false });
                }
                else {
                    caseNumberRef.current.setValidationMessage("");
                    changeCaseNumberIconsDisable({ search: false, copy: false, clear: false });
                }
            }
            else {
                caseNumberRef.current.setValidationMessage("");
                changeCaseNumberIconsDisable({ search: false, copy: false, clear: false });
            }
            // Update input value
            setCaseNumberSearch(valueText);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCaseChange");
        }
    };


    // Function to handle search
    const handleSelectCaseFromGrid = async (params) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            await loadCaseDetailsbyID(params.row.caseNumber);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSelectCaseFromGrid");
        }
        finally { setIsPageLoading(false); }
    };

    const handleSelectExternalDocsFromGrid = async (params) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const { documentUNCPath } = params.row;
            //const { completeDocumentPath } = params.row;
            const { batchDocumentID } = params.row;

            setExternalDocumentInViewer(batchDocumentID, documentUNCPath);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSelectExternalDocsFromGrid");
        }
        finally { setIsPageLoading(false); }
    }

    const handleSelectDocsFromGrid = async (params) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const { documentUNCPath } = params.row;
            //const { completeDocumentPath } = params.row;
            const { batchDocumentID } = params.row;

            setDocumentInViewer(batchDocumentID, documentUNCPath);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSelectDocsFromGrid");
        }
        finally { setIsPageLoading(false); }
    }

    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };


    const handleAlertClose = () => {
        setAlertProps((prevState) => ({ ...prevState, open: false }));
    };

    const handleDocChange = (e, tabId) => {
        setDocument((prev) => ({
            ...prev,
            [tabId]: { ...prev[tabId], ['value']: e.target.value }

        }),
        );
        // console.log(document, 'doc');
    }


    const handleCaseDetailChange = (event, newValue, reason) => {
        // console.log("handleCaseDetailChange fired with newValue:", newValue);
    
        // // Handle if newValue is an array (take first element)
        // const selectedOption = Array.isArray(newValue) ? newValue[0] : newValue;
    
        // if (!selectedOption || !selectedOption.value) {
        //     console.log("selectedOption is invalid:", selectedOption);
        //     return;
        // }
        // console.log("Setting currentPanelID to:", selectedOption.value);
        // setCurrentPanelID(selectedOption.value);
        if (!newValue || !newValue.value) return;
        setCurrentPanelID(newValue.value); 
    };

    const handleCaseDetailInternalChange = (caseID) => (event, newValue, reason) => {
        //const { name, value } = event.target;
        // const selectedOption = Array.isArray(newValue) ? newValue[0] : newValue;
        // setCurrentInternalPanelID(selectedOption.value);
        // updateCaseInfo(caseID, {currentCaseDetailID: selectedOption.value });
        if (!newValue || !newValue.value) return;
        setCurrentInternalPanelID(newValue.value);
        updateCaseInfo(caseID, {currentCaseDetailID: newValue.value });
    };

    


    const handleScroll = (e) => {
        // debugger;
        if (scrollRef.current) {
            // console.log(e.target.scrollLeft);
            const { scrollLeft, scrollRight } = scrollRef.current;
            // console.log(scrollLeft, scrollRight, "hello");
        }
    }

    //=======================================================================
    // Action Events - End
    //=======================================================================



    //=======================================================================
    // Batch Document - On load of external batch document  - Begin
    //=======================================================================

    const getBatchDocsByBatchID = async (batchID, isSplit = false) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const params = {
                loginID: loginLegacyUserID,
                onlyBatchID: batchID
            }
            const batchDocsApiData = await ApiManager.GetBatchDocsFromApiByBatchID(params);
            if (batchDocsApiData.length > 0) {
                await LoadDocByBatchID(batchDocsApiData, isSplit);
            }
            else {
                clearBatchDocumentArray();
                onBatchDocAvailable(batchDocumentProcess.DocumentNotAvailable, []);
                onMessageUpdate("No Document Found!");
            }
        }
        catch (error) {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
            onMessageUpdate("No Document Found!");

            throw LoggerUtility.ProcessErrorData(error, "getBatchDocsByBatchID", {});
        }
        finally { setIsPageLoading(false); }
    };

    const LoadDocByBatchID = async (batchDocsData, isSplit = false) => {
        try {
            // Filter completed and pending items
            const completedItems = batchDocsData.filter(item => item.documentStatusID === 5);
            const pendingItems = batchDocsData.filter(item => item.documentStatusID === 32);

            if (pendingItems.length > 0) {

                // Sort pending items by doc_Id first, then by id
                const sortedPendingItems = pendingItems.sort((a, b) => {
                    if (a.documentOrder !== b.documentOrder) {
                        return a.documentOrder - b.documentOrder; // Sort by Document Order
                    }
                    return a.batchDocumentID - b.batchDocumentID; // Tie-breaker: Sort by Batch Document ID if Document Order is same
                });

                sortedPendingItems.forEach(item => {
                    item.indexComplete = false;
                });

                // Pick the first pending item
                const firstPendingItem = sortedPendingItems[0];

                // Calculate the 1-based index for the first pending item, considering completed items
                const indexOfFirstPendingItem = completedItems.length + 1;

                const batchDocumentData = {
                    sortedBatchDocs: sortedPendingItems,
                    currentDocCount: indexOfFirstPendingItem,
                    TotalDocCount: batchDocsData.length,
                    currentIndex: 0
                };

                SessionManager.SetSession(SessionManager.BatchDocumentsKey, JSON.stringify(batchDocumentData));

                if (firstPendingItem) {
                    await ProcessPendingBatchDocument(firstPendingItem, indexOfFirstPendingItem, batchDocsData.length, isSplit);
                }
                else {
                    clearBatchDocumentArray();
                    onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
                    onMessageUpdate("No Document Found!");
                }
            }
            else {
                clearBatchDocumentArray();
                onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
                onMessageUpdate("No Document Found!");
            }
        }
        catch (error) {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
            onMessageUpdate("No Document Found!");

            throw LoggerUtility.ProcessErrorData(error, "LoadDocByBatchID", {});
        }
    };


    const ProcessPendingBatchDocument = async (batchDocData, currentDocCount, totalDocCount, isSplit = false) => {
        try {
            if (batchDocData) {
                if (!isSplit) {
                    const docsUncAPI = ApiManager.DocumentUncApiUrl;
                    const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(docsUncAPI, batchDocData.documentUNCPath);
                    /*if(hasError) {
                        throw errorList;
                    } */
                    //const fileUrl = await DocumentUtility.GetFileUncPath(docsUncAPI, batchDocData.documentUNCPath);
                    setBatchDocument({ BatchID: batchDocData.batchID, BatchDocumentID: batchDocData.batchDocumentID, DocumentPath: fileUrl });
                    await setBatchDocumentInViewer(batchDocData.batchDocumentID, fileUrl);  //  CODE_MODIFY: Modify the line to change the parameter from yTracCaseID  to batchdocumentid
                }
                let statusID = 0;
                if (currentDocCount === totalDocCount) { statusID = 3; } else { statusID = 2; }  // TO-DO: Modify Code -- Hard-coded status value
                const updatedBatchDoc = { ...batchDocData, batchStatusID: statusID }
                onBatchDocAvailable(batchDocumentProcess.HasDocumentForIndex, updatedBatchDoc);
                onMessageUpdate("Document " + (currentDocCount) + " of " + totalDocCount);
                /* if (!isFileExists) {
                    handleNotificationDialog(EnumUtility.NotificationAlerts.DocumentNotFound);
                } */
            }
            else {
                clearBatchDocumentArray();
                onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
                onMessageUpdate("No Document Found!");
            }
        }
        catch (error) {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
            onMessageUpdate("No Document Found!");

            throw LoggerUtility.ProcessErrorData(error, "ProcessPendingBatchDocument", {});
        }
    };

    // Function to handle the process of documents post the split of a document
    const handleLoadDocAfterSplit = async (batchID) => {
        try {
            //setSelectedData([]);
            await getBatchDocsByBatchID(batchID, true);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleLoadDocAfterSplit");
        }
    };

    // Function to handle loading of document from batch by external component
    const onLoadDocFromBatchExternal = async (batchID, showExtDocGrid) => {
        try {
            //setSelectedData([]);
            await getBatchDocsByBatchID(batchID);
            addCaseTabFromBatchExternal(batchID, showExtDocGrid);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadDocFromBatchExternal");
        }
    };

    // Function to handle loading of next document from batch by external component
    const onLoadNextDocFromBatchExternal = async (batchID, showExtDocGrid, batchDocData, currentDocCount, totalDocCount) => {
        try {
            addCaseTabFromBatchExternal(batchID, showExtDocGrid);
            //setSelectedData([]);
            await ProcessPendingBatchDocument(batchDocData, currentDocCount, totalDocCount);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadNextDocFromBatchExternal");
        }
    };

    const addCaseTabFromBatchExternal = (batchID, showExtDocGrid) => {
        try {
            setExternalCaseTabs((prevTabs) => {
                // Check if the tab already exists
                const existingTabIndex = prevTabs.findIndex(
                    (tab) => tab.parentID === batchID && tab.tabKey === CaseTabType.BATCH.ID
                );

                if (existingTabIndex < 0) {
                    // Check if the case tab already exists
                    const existingCaseTabIndex = prevTabs.findIndex(
                        (tab) => tab.parentID === batchID && tab.tabKey === CaseTabType.CaseExternal.ID
                    );

                    if (existingCaseTabIndex < 0) {
                        const newTab = {
                            tabKey: CaseTabType.BATCH.ID,
                            uniqueID: batchID + "_" + tabIndexCounter,
                            parentID: batchID,
                            pid: batchID,
                            label: `BID: ${batchID}`,
                            showDocumentGrid: showExtDocGrid,
                            canDelete: false,
                            documentPath: getBatchDocument.DocumentPath
                        }

                        // If the tab does not exist, add it to the first position and shift others
                        const updatedTabs = [newTab, ...prevTabs.filter((tab) => tab.tabKey === CaseTabType.CaseInternal.ID)];
                        setCurrentExternalCaseTab(newTab.uniqueID);
                        setCurrentInternalCaseTab(false);
                        return updatedTabs;
                    }
                    else {
                        // If the tab exist, update the values
                        const newCaseTabs = prevTabs.map((tab) =>
                            tab.tabKey === CaseTabType.BATCH.ID || tab.tabKey === CaseTabType.CaseExternal.ID
                                ? {
                                    ...tab,
                                    tabKey: CaseTabType.BATCH.ID,
                                    uniqueID: tab.uniqueID,
                                    parentID: tab.parentID,
                                    pid: batchID,
                                    label: `BID: ${batchID}`,
                                    showDocumentGrid: tab.showDocumentGrid,
                                    canDelete: tab.canDelete,
                                    documentPath: tab.documentPath
                                }
                                : tab
                        );

                        setCurrentExternalCaseTab(prevTabs[existingCaseTabIndex]?.uniqueID);
                        setCurrentInternalCaseTab(false);
                        return newCaseTabs;
                    }
                }
                else {
                    setCurrentExternalCaseTab(prevTabs[existingTabIndex]?.uniqueID);
                    setCurrentInternalCaseTab(false);
                    return prevTabs;
                }
            });

            incrementTabCount();
            setShowSearch(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseTabFromBatchExternal", {});
        }
    };

    // Function to clear case information from the tabs if present on click of "No Case" in "New Document" page
    const clearCaseTabFromExternal = (batchID, showExtDocGrid) => {
        try {
            addCaseTabFromBatchExternal(batchID, showExtDocGrid);
            //setSelectedData([]);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearCaseTabFromExternal", {});
        }
    };
    

    // Function to clear case information from the tabs if present on click of "No Case" in "New Document" page
    const clearCaseInfoFromExternal = async () => {
        try {
            setCurrentCaseID("");
            setCaseDetailLoaded(false);

            // Remove all "No Case Workflow" tabs from the internal caseTabs array,
            // parallel to how external Case tabs are cleared by onClearExternalTabs().
            setCaseTabs(prevTabs => {
                const removedNoCaseTabs = prevTabs.filter(t => t.noCase);
                const nextTabs = prevTabs.filter(t => !t.noCase);

                // Clean up cached form/grid data for removed No Case tabs
                removedNoCaseTabs.forEach(t => {
                    if (dataRefs.current[t.pid]) delete dataRefs.current[t.pid];
                });

                // If the currently-active internal tab was a No Case tab, fall back
                // to the first remaining internal tab (or none).
                setCurrentInternalCaseTab(currentUniqueID => {
                    if (nextTabs.some(t => t.uniqueID === currentUniqueID)) return currentUniqueID;
                    return nextTabs[0]?.uniqueID ?? false;
                });

                return nextTabs;
            });

            await onClearExternalTabs();
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearCaseInfoFromExternal", {});
        }
    };

    const setBatchDocumentInViewer = async (batchDocumentID, completeDocumentPath) => {
        try {
            setUncBatchDocumentUrl(completeDocumentPath);
            setEnableShowBatchDocument(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setBatchDocumentInViewer", {});
        }
    };

    const clearBatchDocumentArray = async () => {
        try {
            setBatchDocument({ BatchID: 0, BatchDocumentID: 0, DocumentPath: '' });
            setEnableShowBatchDocument(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearBatchDocumentArray", {});
        }
    };

    //=======================================================================
    // Batch Document - On load of external batch document - End
    //=======================================================================


    //=======================================================================
    //  Methods - Begin
    //=======================================================================

   
    useEffect(() => {
        if (currentActiveExternalTab && currentExternalTabData) {
            const caseData = dataRefs.current[currentActiveExternalTab.pid].formData;
            const showNdi = caseData?.ndiChipDisplay?.trim();
            const showFVIChip = CaseWorkflowService.checkFamilyViolence(caseData);
            const showConfidentialChip = CaseWorkflowService.checkConfidential(caseData);
            const showCaseClosedChip = CaseWorkflowService.checkCaseClosed(caseData);
            const showSpecialCircumstanceChip = CaseWorkflowService.checkSpecialCircumstance(caseData);
            
            setFormFieldAccess({
                ...formFieldAccess,
                confidentialCaseLbl: {
                    ...formFieldAccess.confidentilCaseLbl,
                    hide: !showConfidentialChip
                },
                familyViolenceLbl: {
                    ...formFieldAccess.familyViolenceLbl,
                    hide: !showFVIChip && !caseData?.fviChipDisplay?.trim()
                },
                ndiLbl: {
                    ...formFieldAccess.ndiLbl,
                    hide:  !showNdi
                },
                specialCircumstanceLbl: {
                    ...formFieldAccess.specialCircumstanceLbl,
                    hide: !showSpecialCircumstanceChip
                },
                caseClosedLbl: {
                    ...formFieldAccess.caseClosedLbl,
                    hide: !showCaseClosedChip
                }
            })
        }
        if (currentActiveInternalTab && currentInternalCaseTabData) {
            const caseData = dataRefs.current[currentActiveInternalTab.pid].formData
            const showCaseClosedChip = CaseWorkflowService.checkCaseClosed(caseData);
            const showSpecialCircumstanceChip = CaseWorkflowService.checkSpecialCircumstance(caseData);
            const showNdi = caseData?.ndiChipDisplay?.trim();
            setFormFieldAccess({
                ...formFieldAccess,                
                ndiLbl: {
                    ...formFieldAccess.ndiLbl,
                    hide: !showNdi
                },
                caseClosedLbl: {
                    ...formFieldAccess.caseClosedLbl,
                    hide: !showCaseClosedChip
                },
                 specialCircumstanceLbl: {
                    ...formFieldAccess.specialCircumstanceLbl,
                    hide: !showSpecialCircumstanceChip
                },
            })
        }
    }, [currentActiveExternalTab, currentActiveInternalTab])

    const fetchCaseDataOnly = async (caseID, caseSearchSource) => {
        const correctCaseSearchData = await getCaseDataByID(caseID, false);//forceDatabase = false
        let caseData = correctCaseSearchData.caseInfo;
        if (correctCaseSearchData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID && caseData) {
            caseData = await CaseWorkflowService.buildYTracCaseData(caseData, stateID, false);
            const isMainframeIntegration = UtilityLibrary.DetermineIfMainframeHost();
            if (isMainframeIntegration) {
                // Wrap in try-catch: a save failure must not propagate and hide already-fetched case data.
                try {
                    await ApiManager.PostCaseDataFromScrapeToApi(caseData);
                } catch (scrapeError) {
                    LoggerUtility.ManageErrorLogging(scrapeError, errorFormName, "PostCaseDataFromScrapeToApi");
                }
            }
            const { caseInfo, ...rest } = correctCaseSearchData;
            const returnData = {
                hasCaseData: caseData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID,
                ...rest,
                caseData: caseData
            }
            if (onCaseSearchComplete) {
                onCaseSearchComplete(true, returnData, caseSearchSource);
            }
        }
    }
    
    const showAddIcon = Array.isArray(caseTabs) &&
        caseTabs.filter((tab) => tab?.tabKey === CaseTabType.CaseInternal.ID).length < 3;

    const showBatchAddIcon = Array.isArray(externalCaseTabs) &&
        externalCaseTabs.filter((tab) => ((tab?.tabKey === CaseTabType.BATCH.ID) || (tab?.tabKey === CaseTabType.CaseExternal.ID))).length === 1 &&
        Array.isArray(caseTabs) &&
        caseTabs.filter((tab) => tab?.tabKey === CaseTabType.CaseInternal.ID).length === 0;
    
    // Function to handle loading of case from external search
    const onSelectCaseFromExternal = async (caseID, showExtDocGrid, caseSearchSource, isNoCase = false, caseWorkflowID = null) => {
        try {

            caseID = toUpperCase(caseID);
            let caseInfoData = await addCaseTabFromExternal(caseID, showExtDocGrid, isNoCase, caseWorkflowID);

            // Handle both string and object error messages
            let errorMessageText = '';
            
            if (typeof caseInfoData.errorMessage === 'string') {
                errorMessageText = caseInfoData.errorMessage;
            } else if (typeof caseInfoData.errorMessage === 'object' && caseInfoData.errorMessage?.Message) {
                errorMessageText = caseInfoData.errorMessage.Message;
            }
           
            if (caseInfoData.hasCaseData) {
                if (caseInfoData.skipTabCreation) { 
                    setCurrentCaseID("");
                    setCaseDetailLoaded(false);
                    await onClearExternalTabs();
                    setShowSearch(true);
                }
                else {
                    setCurrentCaseID(isNoCase ? "PLACEHOLDER" : caseID);
                    setCaseDetailLoaded(true);
                    if(isNoCase) {setCurrentPanelID(caseDetailOptions.Document.value)}; 
                    //documentCaseDetailPanelSelection(caseDetailOptions.Document.value, caseID);
                    setShowSearch(false);
                }

                if (onCaseSearchComplete) {
                    onCaseSearchComplete(true, caseInfoData, caseSearchSource);
                }
            }
            else {
                setCurrentCaseID("");
                setCaseDetailLoaded(false);
                await onClearExternalTabs();
                //clearCaseTabFromExternal(getBatchDocument.BatchID, false);
                if (onCaseSearchComplete) {
                   onCaseSearchComplete(false, caseInfoData, caseSearchSource);
                }
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onSelectCaseFromExternal", {});
        }
    };

    // Function to handle clearing of case tab from external search
    const onClearExternalTabs = async () => {
        try {
            setExternalCaseTabs([]);
            setCurrentExternalCaseTab(false);

            if (caseTabs.length === 3) {
                setShowSearch(false);
                setCurrentInternalCaseTab(caseTabs[0].uniqueID);
            }
            else {
                setShowSearch(true);
                setCurrentInternalCaseTab(caseTabs.length);
                setViewedCaseIDRecords();
            }

            /* if (caseTabs.length === 0) {
                setShowSearch(true);
                setCurrentInternalCaseTab(caseTabs.length);
                setViewedCaseIDRecords();
            }
            else if (caseTabs.length > 0) {
                const isLastTabActive = currentInternalCaseTab === caseTabs.length;
                if ((isLastTabActive) || (!currentInternalCaseTab)) {
                    setCurrentInternalCaseTab(caseTabs.length);
                }
            } */
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onClearExternalTabs", {});
        }
    }

    const addCaseTabByCaseID = async (caseID) => {
        try {
            const tab = caseTabs.find((tab) => tab.pid.toString() === caseID && tab.tabKey === CaseTabType.CaseInternal.ID);
            if (tab) {
                setCurrentInternalCaseTab(tab.uniqueID);
                /* const responseData = await getCaseDocsByCaseID(tab.pid, tab.showDocumentGrid);
                setDocResults(responseData || []); */
            }
            else {
                const activeTabs = caseTabs.filter((tab) => tab.tabKey === CaseTabType.CaseInternal.ID).length;
                if (activeTabs < 3) {
                    const newTab = { tabKey: CaseTabType.CaseInternal.ID, uniqueID: caseID + "_" + tabIndexCounter, parentID: 0, pid: caseID, label: `CID: ${UtilityLibrary.cleanString(caseID) || ''}`, showDocumentGrid: true, canDelete: activeTabs > 0 ? true : false }
                    setCaseTabs((prevTabs) => [...prevTabs, newTab]);
                    incrementTabCount();
                    setCurrentInternalCaseTab(newTab.uniqueID);
                    /* const responseData = await getCaseDocsByCaseID(newTab.pid, newTab.showDocumentGrid);
                    setDocResults(responseData || []); */

                }
            }
            //getCaseDetails(caseID, false);
            setShowSearch(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseTabByCaseID", {});
        }
    }

    useEffect(() => {
        try {
            setViewedCaseIDRecords();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "setViewedCaseIDRecords - Page Load");
        }
    }, []);

    const updateCaseSearchResultsWithNewCase = (newCaseData) => {
        try {
            setCaseSearchResults(prevResults => {
                // Find if case already exists in current results
                const existingIndex = prevResults.findIndex(item => item.caseNumber === newCaseData.caseNumber);
                
                if (existingIndex !== -1) {
                    // Replace existing case with updated data
                    const updatedResults = [...prevResults];
                    updatedResults[existingIndex] = { ...updatedResults[existingIndex], ...newCaseData };
                    console.log(`🔍 Updated existing case ${newCaseData.caseNumber} in search results`);
                    return updatedResults;
                } else {
                    // Add new case to the beginning of the list
                    console.log(`🔍 Added new case ${newCaseData.caseNumber} to search results`);
                    return [newCaseData, ...prevResults];
                }
            });
            
            setHasCaseResults(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "updateCaseSearchResultsWithNewCase", {});
        }
    };

    // Around line 1520 in setViewedCaseIDRecords function
    const setViewedCaseIDRecords = () => {
        try {
            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey) || [];
            if (storedData.length > 0) {
                // 🔍 FIXED: Remove duplicates before displaying
                const uniqueCaseData = [];
                const seenCaseNumbers = new Set();
                
                // Process from newest to oldest to keep most recent data
                for (let i = storedData.length - 1; i >= 0; i--) {
                    const item = storedData[i];
                    if (!seenCaseNumbers.has(item.caseNumber)) {
                        seenCaseNumbers.add(item.caseNumber);
                        uniqueCaseData.unshift(item); // Add to beginning to maintain order
                    }
                }
                
                console.log(`🔍 Session: ${storedData.length} total, ${uniqueCaseData.length} unique cases displayed`);
                
                setCaseSearchResults(uniqueCaseData);
                setHasCaseResults(true);
            }
            else { 
                setCaseSearchResults([]);
                setHasCaseResults(false); 
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setViewedCaseIDRecords", {});
        }
    };


    // Around line 1607-1670 in addCaseTabFromExternal function
    const addCaseTabFromExternal = async (caseID, showExtDocGrid, isNoCase = false, caseWorkflowID) => {
        try {
            // Handle no-case scenario
            if (isNoCase) {
                // Create mock case data for no-case workflow
                const caseInfoData = await addCaseInfoToDataRefs(caseID, false, true);
                
                // Check for existing no-case tab
                const existingNoCaseTab = caseTabs.find((tab) => 
                    tab.pid === caseID && tab.tabKey === CaseTabType.CaseInternal.ID && tab.noCase
                );
                
                if (existingNoCaseTab) {
                    // Activate existing no-case tab
                    setCaseTabs((prevTabs) => prevTabs.map((tab) =>
                        tab.uniqueID === existingNoCaseTab.uniqueID
                            ? { ...tab, caseWorkflowID: caseWorkflowID ?? caseID }
                            : tab
                    ));
                    setCurrentInternalCaseTab(existingNoCaseTab.uniqueID);
                    setCurrentExternalCaseTab(false);
                } else {
                    // Create new no-case tab
                    const newtabUniqueIdentifier = `nocase_${caseID}_${tabIndexCounter}`;
                    const newTab = {
                        tabKey: CaseTabType.CaseInternal.ID,
                        uniqueID: newtabUniqueIdentifier,
                        parentID: caseID,
                        pid: caseID,
                        label: "No Case Workflow",
                        showDocumentGrid: showExtDocGrid,
                        canDelete: true,
                        noCase: true,
                        caseWorkflowID: caseWorkflowID ?? caseID
                    }; 

                    setCaseTabs((prevTabs => [...prevTabs, newTab]));
                    setCurrentInternalCaseTab(newTab.uniqueID);
                    setCurrentExternalCaseTab(false);   

                    incrementTabCount();
                }
                
                return {
                    hasCaseData: true,
                    caseData: caseInfoData.caseInfo,
                    statusCode: caseInfoData.statusCode,
                    errorMessage: caseInfoData.errorMessage,
                };
            }

            // Case Scenario
            caseID = toUpperCase(caseID);

       
            const alwaysSearchStateSystem = true;
            
            // 🔍 STEP 1: Get case data first to check if case exists
            const caseInfoData = await addCaseInfoToDataRefs(caseID);
            // 🔍 FIXED: Use statusCode instead of isCaseFound
            const hasCaseData = caseInfoData.statusCode === EnumUtility.CaseSearchResultCode.CaseFound.ID;
            
            // 🔍 STEP 2: If case not found, return early without creating any tabs, could be due to mainframesessiondisconnected also
            if (!hasCaseData) {
                console.log(`🔍 Case ${caseID} not found or mainframe is disconnected - no tab will be created`);
                return { 
                    hasCaseData, 
                    caseData: null, 
                    statusCode: caseInfoData.statusCode, 
                    errorMessage: caseInfoData.errorMessage 
                };
            }

            let isCaseConfidential = false;
            let isConfidentialForThisUser = false;
            if (CaseWorkflowService.checkConfidential(caseInfoData.caseInfo)) {
                isCaseConfidential = true;
                const confidentialCaseKey = `confidentialCaseUser_${caseID}`;
                isConfidentialForThisUser =
                    SessionManager.GetValueFromSession(confidentialCaseKey) === "true";

                if (isConfidentialForThisUser) {
                    if (dataRefs.current[caseID]) {
                        delete dataRefs.current[caseID];
                    }
                    return {
                        hasCaseData: true,
                        caseData: caseInfoData.caseInfo,
                        statusCode: caseInfoData.statusCode,
                        errorMessage: caseInfoData.errorMessage,
                        isCaseConfidential,
                        isConfidentialForThisUser,
                        skipTabCreation: true
                    };
                }
            }
            
            // 🔍 STEP 3: Case exists - proceed with tab management
            const existingExternalTab = externalCaseTabs.find((tab) => tab.pid.toString() === caseID && tab.tabKey === CaseTabType.CaseExternal.ID);
            
            // 🔍 STEP 4: Always remove any internal tab with the same case ID
            const existingInternalTab = caseTabs.find((tab) => tab.pid.toString() === caseID && tab.tabKey === CaseTabType.CaseInternal.ID);
            if (existingInternalTab) {
                setCaseTabs((prevTabs) => prevTabs.filter((tab) => tab.uniqueID !== existingInternalTab.uniqueID));
                console.log(`🔍 Removed internal tab for case ${caseID} - replacing with external tab`);
            }
            
            if (existingExternalTab) {
                // Keep the tab associated with the workflow currently loaded by Next Work Item.
                setExternalCaseTabs((prevTabs) => prevTabs.map((tab) =>
                    tab.uniqueID === existingExternalTab.uniqueID
                        ? { ...tab, caseWorkflowID }
                        : tab
                ));
                setCurrentExternalCaseTab(existingExternalTab.uniqueID);
                setCurrentInternalCaseTab(false);
                console.log(`🔍 Activated existing external tab for case ${caseID}`);
            }
            else {
                // No existing external tab - create new one
                setExternalCaseTabs((prevTabs) => {
                    const newTab = {
                        tabKey: CaseTabType.CaseExternal.ID,
                        uniqueID: caseID + "_" + tabIndexCounter,
                        parentID: caseID,
                        pid: caseID,
                        label: `CID: ${UtilityLibrary.cleanString(caseID) || ''}`,
                        showDocumentGrid: true,
                        canDelete: false,
                        caseWorkflowID
                    };

                    const updatedTabs = [newTab, ...prevTabs.filter((tab) => tab.tabKey === CaseTabType.CaseInternal.ID)];
                    setCurrentExternalCaseTab(newTab.uniqueID);
                    setCurrentInternalCaseTab(false);
                    console.log(`🔍 Created new external tab for case ${caseID}`);
                    return updatedTabs;
                });
                
                incrementTabCount();
            }
            
            return { 
                hasCaseData: true, 
                caseData: caseInfoData.caseInfo, 
                statusCode: caseInfoData.statusCode, 
                errorMessage: caseInfoData.errorMessage,
                isCaseConfidential,
                isConfidentialForThisUser
            };
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseTabFromExternal", {});
        }
    };

    const addNewDocumentToGridRow = async (caseID, newCaseDocumentData) => {
        try {
            caseID = toUpperCase(caseID);
            if (!dataRefs.current[caseID]) return;

            dataRefs.current[caseID].gridData.push(newCaseDocumentData);

            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey);
            if (storedData.length > 0) {
                // Find and update the specific record in session
                const recordIndex = storedData.findIndex((rec) => toUpperCase(rec.caseNumber) === caseID);
                if (recordIndex !== -1) {
                    storedData[recordIndex].caseDocs.push(newCaseDocumentData);
                }

                // Save updated data back to session
                SessionManager.SetSession(SessionManager.CaseInformationKey, JSON.stringify(storedData));
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addNewDocumentToGridRow", {});
        }
    };

    // Handler to increment count
    const incrementTabCount = () => {
        try {
            setTabIndexCounter((prevCount) => prevCount + 1);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "incrementTabCount", {});
        }
    };


    const onSelectDocsFromExternal = async (batchDocumentID, completeDocumentPath) => {
        try {
            setBatchDocumentInViewer(batchDocumentID, completeDocumentPath);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onSelectDocsFromExternal", {});
        }
    }

    const setExternalDocumentInViewer = async (batchDocumentID, completeDocumentPath) => {
        try {
            //if (testDocLoad) { setDocumentUrl('document-003.pdf'); } else { setDocumentUrl('document-004.pdf'); }

            const docsUncAPI = ApiManager.DocumentUncApiUrl;
            const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            //const fileUrl = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            setUncExternalDocumentUrl(fileUrl);
            setEnableShowExternalDocument(true);

        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setDocumentInViewer", {});
        }
    }

    const setDocumentInViewer = async (batchDocumentID, completeDocumentPath) => {
        try {
            //if (testDocLoad) { setDocumentUrl('document-003.pdf'); } else { setDocumentUrl('document-004.pdf'); }

            const docsUncAPI = ApiManager.DocumentUncApiUrl;
            const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            //const fileUrl = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            setUncDocumentUrl(fileUrl);
            setEnableShowDocument(true);
            /* 
                    if (isFileExists) {
                        setEnableShowDocument(true);
                    }
                    else {
                        setEnableShowDocument(false);
                        if (batchDocumentID !== -20) {
                            handleNotificationDialog(EnumUtility.NotificationAlerts.DocumentNotFound);
                        }
            
                    } */
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setDocumentInViewer", {});
        }
    }

    const handleNotificationDialog = (dialogContent, timerDuration = 0, position = "center", backdropDismissal = false) => {
        try {
            setNotificationDialogContent(dialogContent);
            setNotificationDialogPosition(position);
            setNotificationDialogTimer(timerDuration);
            setNotificationBackDropDismissal(backdropDismissal);
            if (timerDuration) {
                setNotificationAutoClose(true);
            }
            else {
                setNotificationAutoClose(false);
            }
            handleOpenNotificationDialog();
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleNotificationDialog", {});
        }
    };

    const handleOpenNotificationDialog = () => {
        try {
            setNotificationDialogOpen(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleOpenNotificationDialog", {});
        }
    };

    const handleCloseNotificationDialog = useCallback(() => {
        try {
            setNotificationDialogOpen(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleCloseNotificationDialog", {});
        }
    }, []);

    const handleTestCaseTabClick = () => {
        console.log("Current Tab: " + currentInternalCaseTab);
        console.log("Case Tab Length: " + caseTabs.length);
    }

    const handleSpecialCircumstanceClick = (caseData) => {
        try {
            setHtmlDialogTitle(`Special Circumstance | Case Number ${caseData.caseNumber}`);
            setHtmlDialogContent(caseData.specialCircumstanceContent || "No special circumstance information available.");
            setHtmlDialogOpen(true);
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSpecialCircumstanceClick");
        }
    }
    const handlePDFViewerError = async(errorMessage, documentDetails) => {
        const loginUserInfo = sessionService.getUser();
        const { stateName, firstName, lastName} = loginUserInfo
        const { batchDocumentID, batchID } = documentDetails
        const currentDate = UtilityLibrary.formatDate(new Date(), customDateFormat);
        
        const dialogMessage = `Document Preview Failed. Please contact Helpdesk.
        Exception = ${errorMessage}
        Date/Time of Error = ${currentDate}
        Page = ${pageName}
        State = ${stateName}
        User = ${firstName} ${lastName}
        Region =  ${configLibrary.hostedEnvironment}            
        CaseNumber = ${(currentActiveExternalTab ? dataRefs.current?.[currentActiveExternalTab?.pid]?.formData?.caseNumber :
                dataRefs.current?.[currentActiveInternalTab?.pid]?.formData?.caseNumber) || ""}
        Batch ID = ${batchID}
        Document ID = ${batchDocumentID}`;
        
        handleNotificationDialog({ NotificationType: "error", Message: dialogMessage })
    }


    /* 
    * Authorization code starts here
    * The permission values for fields are received from Web API
    * The received data from Web API response is processed and stored in a state variable "formFieldAccess"
    */
    useEffect(() => {
        const fetchFormFieldPermissions = async () => {
            try {
                const loginUserInfo = sessionService.getUser();
                const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
                const params = {
                    clientID: loginStateID,
                    formID: 40      // To-do: Modify Code - Hard-coded value of FormID: 40
                }
                const controlSecurityListApiData = await ApiManager.FetchControlsPermissions(params);
                const actualPermissionsForFields = DeterminePermissions(controlSecurityListApiData);
                setFormFieldAccess({ ...defaultPermissionsForFields, ...actualPermissionsForFields });
            } catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "fetchFormFieldPermissions", {});
            }
        };

        try {
            fetchFormFieldPermissions();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchFormFieldPermissions - Page Load");
        }
    }, []);

    //=======================================================================
    //  Methods - End
    //=======================================================================


    //=======================================================================
    // Confirmation Dialog - Begin
    //=======================================================================

    const handleConfirmationDialog = (dialogContent) => {
        setConfirmationDialogContent(dialogContent);
        handleOpenConfirmDialog();
    };

    const handleOpenConfirmDialog = () => {
        setConfirmDialogOpen(true);
    };

    const handleCloseConfirmDialog = () => {
        setSplitArgs(null);
        setConfirmDialogOpen(false);
    };

    const handleDialogConfirmAction = async (dialogContentID) => {
        try {
            switch (dialogContentID) {

                case EnumUtility.ConfirmDialogType.SplitDocument.ID:
                    handleConfirmSplit();
                    break;

                default:
                    break;
            }

            setConfirmDialogOpen(false);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    //=======================================================================
    // Confirmation Dialog - End
    //=======================================================================




    //=======================================================================
    // Split Document Process - Begin
    //=======================================================================

    // Handler for the split button press
    const handleSplitButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            // Store the arguments for later use
            setSplitArgs({ setOperations, getSelectedPageIndexes });
            // Show the confirmation dialog
            handleConfirmationDialog(EnumUtility.ConfirmDialogType.SplitDocument);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    // Handler for confirming the split
    const handleConfirmSplit = async () => {
        try {
            if (splitArgs) {
                const { setOperations, getSelectedPageIndexes } = splitArgs;
                // Perform the split operation using the stored arguments
                await performSplitOperation(setOperations, getSelectedPageIndexes);
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    // Function to perform the split operation
    const performSplitOperation = async (setOperations, getSelectedPageIndexes) => {
        try {
            let docSplitData = batchDataService.getSplitDocumentData();
            const totalpageIndexes = UtilityLibrary.itemsArray(docSplitData.batchInstance.totalPageCount);
            const selectedPageIndexes = getSelectedPageIndexes();
            const selectedPageIndexesForProcessing =
                selectedPageIndexes.length === totalpageIndexes.length
                    ? selectedPageIndexes.slice(1)
                    : selectedPageIndexes;
            const remainingPageIndexes = UtilityLibrary.differenceArray(totalpageIndexes, selectedPageIndexesForProcessing);

            if (selectedPageIndexesForProcessing.length > 0) { //TODO Plan A. Prevent split button from being active if no pages are selected
                selectedPageIndexesForProcessing?.length && setOperations((operations) => {

                    if (docSplitData.batchInstance) {
                        docSplitData.batchInstance.exportPDFWithOperations([
                            ...operations,
                            { type: "removePages", pageIndexes: remainingPageIndexes },
                        ]).then(async (buffer) => {
                            //this is only necessary if you want to download the file to the current device
                            docSplitData.splitOffBuffer = buffer;
                            docSplitData.splitOffDocument_Blob = new Blob([buffer], { type: "application/pdf" });

                            //console.log("splitOffDocument_Blob size:", splitOffDocument_Blob.size); // Log the size of the blob


                        });
                    }
                    if (docSplitData.batchInstance) {
                        docSplitData.batchInstance.exportPDFWithOperations([
                            ...operations,
                            { type: "removePages", pageIndexes: selectedPageIndexesForProcessing },
                        ]).then(async (buffer) => {
                            //this is only necessary if you want to download the file to the current device
                            docSplitData.currentDocument_Blob = new Blob([buffer], { type: "application/pdf" });
                            //console.log("currentDocument_Blob size:", currentDocument_Blob.size); // Log the size of the blob

                            const customOptions = { origin: "CaseInformation" };
                            let pageCount = remainingPageIndexes.length;

                            await batchDataService.UpdateBatchDocument(getBatchDocument.BatchDocumentID, pageCount, getBatchDocument.BatchID, customOptions);  // Update Current Document

                            pageCount = selectedPageIndexesForProcessing.length;
                            await batchDataService.InsertBatchDocument(getBatchDocument.BatchDocumentID, pageCount, getBatchDocument.BatchID, customOptions);  // Create the new split off Document in current Batch

                            docSplitData = batchDataService.getSplitDocumentData();

                            // basePath = \\yt_dev_file.ywcss.local\YWDMS_Dev$\ZZ\
                            // batch Path = 2025\02\22\500920
                            // fileName = 20250222042516.pdf

                            docSplitData.basePath = SessionManager.GetValueFromSession(SessionManager.DocumentPathKey);


                            docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.currentDocumentbatchPath + "\\" + docSplitData.currentDocumentFileName;
                            console.log("Update Existing Document Path: " + docSplitData.documentUNCPath);
                            //await ApiManager.DeleteDocumentFromApi(docSplitData.documentUNCPath);
                            await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);
                            //saveFile(docSplitData.currentDocument_Blob, docSplitData.currentDocumentFileName, docSplitData.documentUNCPath, docSplitData.buffer);  //Save the modified current document to the server.

                            docSplitData.splitOffDocumentbatchPath = docSplitData.currentDocumentbatchPath;

                            docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.splitOffDocumentbatchPath + "\\" + docSplitData.splitDocumentFileName;
                            console.log("Insert New Document Path: " + docSplitData.documentUNCPath);
                            await DocumentUtility.SaveFileToPhysicalPath(docSplitData.splitOffDocument_Blob, docSplitData.documentUNCPath);
                            //saveFile(splitOffDocument_Blob, splitDocumentFileName, documentUNCPath, splitOffBuffer);  //Save the split document to the server.

                            if (pdfViewerRef.current) {
                                await pdfViewerRef.current.handleDocumentExport(buffer, docSplitData.batchInstance);
                            }

                            await handleLoadDocAfterSplit(getBatchDocument.BatchID);

                            //await handleDocumentExport(buffer, docSplitData.batchInstance);

                            // if (origin === "CaseInformation" && onLoadDocAfterSplit) {
                            //     await onLoadDocAfterSplit(props.BatchID);
                            // }

                            handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentIndexSplitSuccess);

                        });
                    }
                    return operations;
                });
            } else {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
            };
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "performSplitOperation", {});
        }
    };


    //=======================================================================
    // Split Document Process - End
    //=======================================================================


    //=======================================================================
    // ROTATE - Save Document Process - Begin
    //=======================================================================

    // Handler for the save rotate button press
    const handleSaveRotateButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            // const { documentBuffer, batchInstance } = await BusinessUtility.PerformSaveAfterRotateOperation(getBatchDocument.BatchDocumentID, setOperations, getSelectedPageIndexes);
            await BusinessUtility.PerformSaveAfterRotateOperation(pdfViewerRef, getBatchDocument.BatchDocumentID, setOperations, getSelectedPageIndexes);
            /*  
             if (pdfViewerRef.current) {
                 await pdfViewerRef.current.handleDocumentExport(documentBuffer, batchInstance);
             } */

            handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentRotateSuccess);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    //=======================================================================
    // ROTATE - Save Document Process - End
    //=======================================================================

    //=======================================================================
    //  - Begin
    //=======================================================================


    //=======================================================================
    //  - End
    //=======================================================================


    


    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


    //const DynamicComponent = currentPanelID ? caseDetailComponentMap[currentPanelID] : null;



    const mainContent = (
        <div className="content-main-container">
            <div className="pane-wrap-container">
                <div className="pane-main-container">
                    <div className="form-section">
                        <Box>
                            {/* Sticky Tabs Container  */}
                            <div 
                                style={{ 
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 11,
                                    backgroundColor: 'white',
                                    padding: '8px 0', 
                                    width: '100%',
                                }}
                            >
                                <Box sx={{ display: "flex", gap: 2 }}>
                                    {/* <Button id="skipDocumentBtn" name="skipDocumentBtn" variant='contained' onClick={handleTestCaseTabClick}>Check Case Tabs</Button> */}
                                    {/* Tabs Section (Only Visible After First Tab is Added) */}
                                    {externalCaseTabs.length > 0 && (
                                        <Tabs
                                            value={currentExternalCaseTab}
                                            onChange={(event, newValue) => { setCurrentExternalCaseTab(newValue); setCurrentInternalCaseTab(false); setShowSearch(false); }}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {externalCaseTabs.map((tab, index) => (
                                                <Tab
                                                    key={tab.uniqueID}
                                                    label={
                                                        <Box display="flex" alignItems="center" style={{ height: "40px" }}>
                                                            {tab.label}
                                                        </Box>
                                                    }
                                                    value={tab.uniqueID}
                                                />
                                            ))}
                                            {/* Disable Add icon when 3 tabs are active */}
                                            {showBatchAddIcon && <IconButton onClick={() => handleAddButtonClick(caseTabs.length)} ><AddIcon className={showBatchAddIcon ? 'primary' : "btn-disabled"} /></IconButton>}
                                        </Tabs>
                                    )}
                                    {caseTabs.length > 0 && (
                                        <Tabs
                                            value={currentInternalCaseTab}
                                            onChange={(event, newValue) => { setCurrentInternalCaseTab(newValue); setCurrentExternalCaseTab(false); setShowSearch(false); }}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {caseTabs.map((tab, index) => (
                                                <Tab
                                                    key={tab.uniqueID}
                                                    label={
                                                        <Box display="flex" alignItems="center" style={{ height: "40px" }}>
                                                            {tab.label}
                                                            {tab.uniqueID == currentInternalCaseTab && (
                                                                tab.canDelete && (
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleRemoveTab(tab.uniqueID, tab.pid);
                                                                        }}
                                                                    // disabled={caseTabs.length == 1 ? true : false}
                                                                    >
                                                                        <CloseRounded fontSize="small" />
                                                                    </IconButton>
                                                                ))
                                                            }
                                                        </Box>
                                                    }
                                                    value={tab.uniqueID}
                                                    onClick={() => handleCaseTabClick(tab.tabKey, tab.pid, tab.showDocumentGrid)}
                                                />
                                            ))}
                                            {/* Disable Add icon when 3 tabs are active */}
                                            {showAddIcon && <IconButton onClick={() => handleAddButtonClick(caseTabs.length)} ><AddIcon className={showAddIcon ? 'primary' : "btn-disabled"} /></IconButton>}
                                        </Tabs>
                                    )}
                                </Box>
                            </div>

                            {/* Content Section */}
                            <Box p={2}>
                                {showSearch && (
                                    <div style={{ padding: '16px' }}>

                                        {/* Search TextField */}
                                        {!(formFieldAccess.caseNumberTxt?.hide ?? false) && (
                                            <TextFieldWithIconButton
                                                ref={caseNumberRef}
                                                nameForField="caseNumberTxt"
                                                onIconButtonClick={handleCaseSearch}
                                                onClearButtonClick={handleCaseClear}
                                                onTextChange={handleCaseChange}
                                                valueForField={caseNumberSearch}
                                                labelForField="Case Search"
                                                iconsTooltipText={{ search: 'Search Case', copy: 'Copy Case', clear: 'Clear Case' }}
                                                isDisabled={!(formFieldAccess.caseNumberTxt?.write ?? true)}
                                                iconsDisabled={caseNumberIconsDisabled}
                                            />
                                        )}

                                        {/* Grid */}
                                        <div style={{ marginTop: '16px' }}>
                                            {!(formFieldAccess.caseSearchDgrd?.hide ?? false) && (
                                                hasCaseResults ?
                                                    <DataGridPremium
                                                        id="caseSearchDgrd"
                                                        name="caseSearchDgrd"
                                                        rows={caseSearchResults}
                                                        columns={caseColumns}
                                                        rowsPerPageOptions={[5]}
                                                        pagination
                                                        pageSizeOptions={[5, 10, 15, 20, 25]}
                                                        paginationModel={caseSearchPaginationModel} // Controlled pagination
                                                        onPaginationModelChange={setCaseSearchPaginationModel} // Handle page changes   
                                                        disableSelectionOnClick
                                                        sortingOrder={['asc', 'desc']}
                                                        onRowClick={handleSelectCaseFromGrid}
                                                        getRowId={(row) => row.caseNumber} // 🔍 FIXED: Use caseNumber as unique ID
                                                        autosizeOnMount
                                                        autosizeOptions={{
                                                            includeHeaders: true,
                                                            includeOutliers: true,
                                                            expand: true
                                                        }}
                                                        sx={{
                                                            "& .MuiDataGrid-row:hover": {
                                                                cursor: "pointer"
                                                            },
                                                            ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                                                "margin-top": "1em",
                                                                "margin-bottom": "1em"
                                                            },
                                                            "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                                        }}
                                                    />
                                                    : initialCaseSearch && (<div className="text-wrapper-subtitle">No recent Case Details found!</div>)

                                            )}
                                        </div>
                                    </div>
                                )}
                                {externalCaseTabs.map((tab) => (
                                    <Box
                                        key={tab.uniqueID}
                                        role="tabpanel"
                                        hidden={currentExternalCaseTab !== tab.uniqueID}
                                    >
                                        {/* Sticky Case Information Section */}
                                        <div 
                                            style={{ 
                                                position: 'sticky',
                                                top: '64px',
                                                zIndex: 10,
                                                backgroundColor: 'white',
                                                padding: '16px 16px 0px', 
                                                width: '100%' 
                                            }}
                                        >
                                            {/* Top Section (Yellow) */}
                                            <div className="form-caseInfo-container">
                                                {!(formFieldAccess.caseNumberLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">Case ID:</label>
                                                        <label id="caseNumberLbl" name="caseNumberLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentExternalFormData.caseNumber) || ''}</label>
                                                    </div>
                                                )}
                                                {!(formFieldAccess.cpNameLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">CP:</label>
                                                        <label id="cpNameLbl" name="cpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(((currentExternalFormData.cpFirstName || '') + ' ' + (currentExternalFormData.cpLastName || '')).trim())}</label>
                                                    </div>
                                                )}
                                                {!(formFieldAccess.statusTypeLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">Case Status:</label>
                                                        <label id="statusTypeLbl" name="statusTypeLbl" className="text-wrapper-subtitle caseInfo-Content">{currentExternalFormData.caseStatus || ''}</label>
                                                    </div>
                                                )}
                                                {!(formFieldAccess.caseTypeLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">Case Type:</label>
                                                        <label id="caseTypeLbl" name="caseTypeLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentExternalFormData.caseType) || ''}</label>
                                                    </div>
                                                )}

                                            </div>
                                            <div className="form-caseInfo-container">
                                                {/* {!(formFieldAccess.openedLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">Opened:</label>
                                                        <label id="openedLbl" name="openedLbl" className="text-wrapper-subtitle caseInfo-Content">{currentExternalFormData.createdTS ? UtilityLibrary.formatDate(currentExternalFormData.createdTS) : ''}</label>
                                                    </div>
                                                )} */}
                                                {!(formFieldAccess.ncpNameLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">NCP:</label>
                                                        <label id="ncpNameLbl" name="ncpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(((currentExternalFormData.ncpFirstName || '') + ' ' + (currentExternalFormData.ncpLastName || '')).trim())}</label>
                                                    </div>
                                                )}
                                                {!(formFieldAccess.caseWorkerLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">Case Worker:</label>
                                                        <label id="caseWorkerLbl" name="caseWorkerLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentExternalFormData.caseWorker) || ''}</label>
                                                    </div>
                                                )}
                                                {!(formFieldAccess.countyNameLbl?.hide ?? false) && (
                                                    <div className="form-caseInfo-field">
                                                        <label className="text-wrapper-subtitle caseInfo-Title">County:</label>
                                                        <label id="countyNameLbl" name="countyNameLbl" className="text-wrapper-subtitle caseInfo-Content">{currentExternalFormData.countyName || ''}</label>
                                                    </div>
                                                )}

                                            </div>
                                            <div className="container-two-column">
                                                <div className='left-column-2c indicatorDiv'>
                                                    {!(formFieldAccess.confidentialCaseLbl?.hide ?? false) && (
                                                        <label id="confidentialCaseLbl" name="confidentialCaseLbl" className="indicatorLabel">Confidential</label>
                                                    )}
                                                    {((!formFieldAccess.familyViolenceLbl?.hide && currentExternalFormData?.fviChipDisplay) ?? false) && (
                                                        <label id="familyViolenceLbl" name="familyViolenceLbl" className="indicatorLabel">{currentExternalFormData.fviChipDisplay}</label>
                                                    )}
                                                     {((!formFieldAccess.ndiLbl?.hide && currentExternalFormData?.ndiChipDisplay) ?? false) && (
                                                        <label id="ndiLbl" name="ndiLbl" className="indicatorLabel">{currentExternalFormData.ndiChipDisplay}</label>
                                                    )} 
                                                     {!(formFieldAccess.specialCircumstanceLbl?.hide ?? false) && (
                                                        <label 
                                                            id="specialCircumstanceLbl" 
                                                            name="specialCircumstanceLbl" 
                                                            className="indicatorLabel"
                                                            onClick={() => handleSpecialCircumstanceClick(currentExternalFormData)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Special Circumstance
                                                        </label>
                                                    )}
                                                    {!(formFieldAccess.goodCauseLbl?.hide ?? false) && (
                                                        <label id="goodCauseLbl" name="goodCauseLbl" className="indicatorLabel indicatorLabelDisabled">Good Cause</label>
                                                    )}
                                                    {!(formFieldAccess.nonCoopLbl?.hide ?? false) && (
                                                        <label id="nonCoopLbl" name="nonCoopLbl" className="indicatorLabel indicatorLabelDisabled">Non Coop</label>
                                                    )}
                                                    {!(formFieldAccess.conflictCaseLbl?.hide ?? false) && (
                                                        <label id="conflictCaseLbl" name="conflictCaseLbl" className="indicatorLabel">Conflict case</label>
                                                    )}
                                                     {!(formFieldAccess.caseClosedLbl?.hide ?? false) && (
                                                        <label id="caseClosedLbl" name="caseClosedLbl" className="indicatorLabel">Closed Case</label>
                                                    )}
                                                </div>
                                                <div className="right-column-2c">
                                                    {!(formFieldAccess.caseDetailSelect?.hide ?? false) && (
                                                        <div style={{ width: '100%' }}>
                                                            <CustomAutoComplete
                                                                customVariant='blueBorderVariant'
                                                                idForControl='caseDetailSelect'
                                                                labelForControl='Case Detail'
                                                                //value={getSelectedCaseDetailOption(currentCaseDetailID)}
                                                                valueForControl={currentPanelID}
                                                                onChange={handleCaseDetailChange}
                                                                optionsSource={caseDetailOptionsForControls}
                                                                labelKey='label'
                                                                valueKey='value'
                                                                multiple={false}
                                                                getOptionLabel={(option) => option?.label || ''}
                                                                isOptionEqualToValue={(option, value) => option?.value === value}
                                                                noOptionsText='Case Detail Not Found'
                                                                allowClear={false}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12' style={{ padding: "5px", borderBottom: '2px solid grey' }}>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Scrollable Content Area */}
                                        <div style={{ overflowY: 'auto' }}>
                                            <div>
                                                {caseDetailLoaded && (
                                                    currentPanelID && (
                                                        <CaseDetailManager
                                                            PrimaryID={tab.pid}
                                                            SelectedCaseDetailID={currentPanelID}
                                                            HandleNotificationDialog={handleNotificationDialog}
                                                            SetSelectedDoc={setSelectedDoc}
                                                            SelectedDoc={selectedDoc}
                                                            HandlePDFViewerError={handlePDFViewerError}
                                                            persistViewerPreferences={true}
                                                            caseWorkflowID={tab.caseWorkflowID}
                                                        />
                                                    ))}
                                            </div>
                                        </div>

                                    </Box>
                                ))}
                                {caseTabs.map((tab) => (
                                    <Box
                                        key={tab.uniqueID}
                                        role="tabpanel"
                                        hidden={currentInternalCaseTab !== tab.uniqueID}
                                    >
                                        {currentInternalCaseTab === tab.uniqueID &&
                                            (
                                                <div>
                                                    {/* Sticky Case Information Section */}
                                                    <div 
                                                        style={{ 
                                                            position: 'sticky',
                                                            top: '64px',
                                                            zIndex: 10,
                                                            backgroundColor: 'white',
                                                            padding: '16px 16px 0px', 
                                                            width: '100%' 
                                                        }}
                                                    >
                                                        {/* Top Section (Yellow) */}
                                                        <div className="form-caseInfo-container">
                                                            {!(formFieldAccess.caseNumberLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">Case ID:</label>
                                                                    <label id="caseNumberLbl" name="caseNumberLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentInternalFormData.caseNumber) || ''}</label>
                                                                </div>
                                                            )}
                                                            {!(formFieldAccess.cpNameLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">CP:</label>
                                                                    <label id="cpNameLbl" name="cpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(((currentInternalFormData.cpFirstName || '') + ' ' + (currentInternalFormData.cpLastName || '')).trim())}</label>
                                                                </div>
                                                            )}
                                                            {!(formFieldAccess.statusTypeLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">Status:</label>
                                                                    <label id="statusTypeLbl" name="statusTypeLbl" className="text-wrapper-subtitle caseInfo-Content">{currentInternalFormData.caseStatus || ''}</label>
                                                                </div>
                                                            )}
                                                            {!(formFieldAccess.caseTypeLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">Type:</label>
                                                                    <label id="caseTypeLbl" name="caseTypeLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentInternalFormData.caseType) || ''}</label>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="form-caseInfo-container">
                                                            {/* {!(formFieldAccess.openedLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">Opened:</label>
                                                                    <label id="openedLbl" name="openedLbl" className="text-wrapper-subtitle caseInfo-Content">{currentInternalFormData.createdTS ? UtilityLibrary.formatDate(currentInternalFormData.createdTS) : ''}</label>
                                                                </div>
                                                            )} */}
                                                            {!(formFieldAccess.ncpNameLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">NCP:</label>
                                                                    <label id="ncpNameLbl" name="ncpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(((currentInternalFormData.ncpFirstName || '') + ' ' + (currentInternalFormData.ncpLastName || '')).trim())}</label>
                                                                </div>
                                                            )}
                                                            {!(formFieldAccess.caseWorkerLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">Case Worker:</label>
                                                                    <label id="caseWorkerLbl" name="caseWorkerLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentInternalFormData.caseWorker) || ''}</label>
                                                                </div>
                                                            )}
                                                            {!(formFieldAccess.countyNameLbl?.hide ?? false) && (
                                                                <div className="form-caseInfo-field">
                                                                    <label className="text-wrapper-subtitle caseInfo-Title">County:</label>
                                                                    <label id="countyNameLbl" name="countyNameLbl" className="text-wrapper-subtitle caseInfo-Content">{UtilityLibrary.cleanString(currentInternalFormData.countyName)  || ''}</label>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="container-two-column">
                                                        <div className='left-column-2c indicatorDiv'>
                                                            
                                                                {((!formFieldAccess.ndiLbl?.hide && currentInternalFormData?.ndiChipDisplay) ?? false) && (
                                                                    <label id="ndiLbl" name="ndiLbl" className="indicatorLabel">{currentInternalFormData.ndiChipDisplay}</label>
                                                                )} 
                                                                {!(formFieldAccess.specialCircumstanceLbl?.hide ?? false) && (
                                                                    <label 
                                                                        id="specialCircumstanceLbl" 
                                                                        name="specialCircumstanceLbl" 
                                                                        className="indicatorLabel"
                                                                        onClick={() => handleSpecialCircumstanceClick(currentInternalFormData)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        Special Circumstance
                                                                    </label>
                                                                )}
                                                                {!(formFieldAccess.goodCauseLbl?.hide ?? false) && (
                                                                    <label id="goodCauseLbl" name="goodCauseLbl" className="indicatorLabel indicatorLabelDisabled">Good Cause</label>
                                                                )}
                                                                {!(formFieldAccess.nonCoopLbl?.hide ?? false) && (
                                                                    <label id="nonCoopLbl" name="nonCoopLbl" className="indicatorLabel indicatorLabelDisabled">Non Coop</label>
                                                                )}
                                                                {!(formFieldAccess.conflictCaseLbl?.hide ?? false) && (
                                                                    <label id="conflictCaseLbl" name="conflictCaseLbl" className="indicatorLabel">Conflict case</label>
                                                                )}
                                                                {!(formFieldAccess.caseClosedLbl?.hide ?? false) && (
                                                                    <label id="caseClosedLbl" name="caseClosedLbl" className="indicatorLabel">Closed Case</label>
                                                                )}
                                                            </div>
                                                            <div className="right-column-2c">
                                                                {!(formFieldAccess.caseDetailSelect?.hide ?? false) && (
                                                                    <div style={{ width: '100%' }}>
                                                                        <CustomAutoComplete
                                                                            customVariant='blueBorderVariant'
                                                                            idForControl='caseDetailSelect'
                                                                            labelForControl='Case Detail'
                                                                            //value={getSelectedCaseDetailOption(tab.noCase ? currentInternalPanelID : caseInternalInfoLookup[tab.pid]?.currentCaseDetailID)} 
                                                                            valueForControl={tab.noCase ? currentInternalPanelID : caseInternalInfoLookup[tab.pid]?.currentCaseDetailID}                        
                                                                            onChange={handleCaseDetailInternalChange(tab.pid)}
                                                                            optionsSource={caseDetailOptionsForControls}
                                                                            labelKey='label'
                                                                            valueKey='value'
                                                                            multiple={false}
                                                                            getOptionLabel={(option) => option?.label || ''}
                                                                            isOptionEqualToValue={(option, value) => option?.value === value}
                                                                            isDisabled={false}
                                                                            noOptionsText='Case Detail Not Found'
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className='row' style={{ padding: "4px" }}>
                                                            <div className='col-12' style={{ padding: "2px", borderBottom: '2px solid grey' }}>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Scrollable Content Area */}
                                                    <div style={{ overflowY: 'auto' }}>
                                                    <div>
                                                        {(caseInternalInfoLookup[tab.pid]?.caseLoaded || tab.noCase) && (
                                                            (caseInternalInfoLookup[tab.pid]?.currentCaseDetailID || tab.noCase) && (
                                                                <CaseDetailManager
                                                                    PrimaryID={tab.noCase ? tab.caseWorkflowID : tab.pid}
                                                                    noCase={tab.noCase || false}
                                                                    SelectedCaseDetailID={tab.noCase ? currentInternalPanelID : caseInternalInfoLookup[tab.pid]?.currentCaseDetailID}
                                                                    HandleNotificationDialog={handleNotificationDialog}
                                                                    SetSelectedDoc={setSelectedDoc}
                                                                    SelectedDoc={selectedDoc}
                                                                    HandlePDFViewerError={handlePDFViewerError}
                                                                    persistViewerPreferences={true}
                                                                    caseWorkflowID={tab.caseWorkflowID}
                                                                />
                                                            ))}
                                                    </div>
                                                    </div>
                                                </div>
                                            )}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </div>
                </div>
            </div >
        </div >
    );
    return (
        <div style={{ height: '100%' }}>
            {mainContent}

            <AlertNotification
                alertType={alertProps.type}
                message={alertProps.message}
                open={alertProps.open}
                onClose={handleAlertClose}
            />

            {/* Include the Confirmation Dialog component */}
            <ConfirmationDialog
                openConfirmation={confirmDialogOpen}
                dialogContent={confirmationDialogContent}
                onCloseConfirmation={handleCloseConfirmDialog}
                onConfirmDialog={(param) => handleDialogConfirmAction(param)}
            />

            {/* Include the Notification Dialog component */}
            <NotificationDialog
                openNotification={notificationDialogOpen}
                dialogContent={notificationDialogContent}
                onCloseNotification={handleCloseNotificationDialog}
                isAutoClose={notificationAutoClose || false}
                position={notificationDialogPosition || "center"}
                timerDuration={notificationDialogTimer || 0}
                backdropDismissal={notificationBackdropDismissal || false}
            />

            {/* Include the HTML Content Dialog for special circumstances */}
            <HtmlContentDialog
                openDialog={htmlDialogOpen}
                onCloseDialog={() => setHtmlDialogOpen(false)}
                title={htmlDialogTitle}
                htmlContent={htmlDialogContent}
                maxWidth="md"
                minHeight={300}
                maxHeight={600}
            />

            {/* Include the loader component */}
            <PageLoader isPageLoading={isPageLoading} />
        </div>
    );
});

export default CaseInformation;






    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


    


    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


